// eslint-disable-next-line no-magic-numbers
const twoPi = 2 * Math.PI;
// Note: it looks like lengthUnits keys are inconsistent with value presets for the unit rule. Meter is defined
// 'meter' here, but as 'm' in the unit rule. Consistency is required, since the unit rule value is used with
// functions that rely on this unit mapping. Not sure if safe to remove existing entries, so leaving those. For
// more information see, LayoutRules.unit.auto_complete_options
const lengthUnits = {
    // unitName: howManyPerMeter
    nm: 1_000_000_000,
    um: 1_000_000,
    mm: 1_000,
    cm: 100,
    // Meters
    meter: 1,
    m: 1,
    // Mil
    mils: 39370.1,
    mil: 39370.1,
    // NOTE: Approx 39.37, but an inch is defined as exactly 2.54cm, so use the exact value not the approx.
    // eslint-disable-next-line no-magic-numbers
    inch: 1 / 0.0254,
    ft: 3.28084,
};
const lengthUnitsKeys = Object.keys(lengthUnits);
const angleUnits = {
    // unitName: howManyInACircle
    rad: twoPi,
    deg: 360,
    grad: 400,
};
export function asLengthUnit(unit) {
    return lengthUnitsKeys.includes(unit) ? unit : null;
}
export function convertLength(value, from, to) {
    return (value / lengthUnits[from]) * lengthUnits[to];
}
export function convertAngle(value, from, to) {
    return (value / angleUnits[from]) * angleUnits[to];
}
export function mmToMeters(mm) {
    return convertLength(mm, "mm", "meter");
}
export function umToMeters(um) {
    return convertLength(um, "um", "meter");
}
export function metersToMm(meters) {
    return convertLength(meters, "meter", "mm");
}
export function metersToUm(meters) {
    return convertLength(meters, "meter", "um");
}
export function metersToCm(meters) {
    return convertLength(meters, "meter", "cm");
}
export function metersToInch(meters) {
    return convertLength(meters, "meter", "inch");
}
export function metersToMils(meters) {
    return convertLength(meters, "meter", "mils");
}
export function centimetersToMeters(centimeters) {
    return convertLength(centimeters, "cm", "meter");
}
export function milsToMm(meters) {
    return convertLength(meters, "mils", "mm");
}
export function milsToMeters(meters) {
    return convertLength(meters, "mils", "meter");
}
export function radiansToDegrees(radians) {
    return convertAngle(radians, "rad", "deg");
}
export function degreesToRadians(degrees) {
    return convertAngle(degrees, "deg", "rad");
}
/** Normalize angle in radians to a value between 0 to 2pi, or if `symmetrical` is
 * specified, a value between -pi to +pi (nicer for many kinds of comparisons,
 * such as checking distance of rotation from origin).
 */
export function normalizeRadians(radians, symmetrical = false) {
    radians = radians % twoPi;
    if (radians < 0)
        radians += twoPi;
    if (symmetrical && radians > Math.PI)
        radians -= twoPi;
    return radians;
}
//# sourceMappingURL=unitConversion.js.map